import React from 'react';
import Routes from './routes';
import Toolbar from './components/Toolbar';
import { useDispatch, useSelector } from 'react-redux';

import selectors from 'state/selectors';
import actions from 'state/actions';
import Modal from 'components/Modal';
import ModalsSwitcher from './components/ModalsSwitcher';

const Normalizer = () => {
  const dispatch = useDispatch();
  const isModalVisible = useSelector(selectors.modal.getVisibility);

  const closeModal = async () => {
    dispatch(actions.modal.closeModal());
  };

  return (
    <>
      <Modal onClose={closeModal} open={isModalVisible}>
        <ModalsSwitcher />
      </Modal>
      <Toolbar />
      <Routes />
    </>
  );
};

export default Normalizer;
